import { Box, Typography } from "@mui/material";

const styles = (theme) => {
  return {
    padding: "8px 16px",
    minHeight: "90px",
    borderBottom: `2px solid ${theme.palette.primary.lighter}`,
    display: "flex",
    justifyContent: "space-between",
    "&:last-child": {
      borderBottom: "unset",
    },
    "& .image-section": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    "& .children-section": {
      width: "70%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
  };
};

const SummaryUsage = ({ icon, label, children }) => {
  return (
    <Box className="summary-usage" sx={(theme) => styles(theme)}>
      <Box className="image-section">
        <div>
          <img src={icon} alt="" />
        </div>
        <Typography variant="subtitle1" fontWeight={700} mt={0.5}>
          {label}
        </Typography>
      </Box>
      <Box className="children-section">{children}</Box>
    </Box>
  );
};

export default SummaryUsage;
